import React from 'react';

const title = 'Banking'; // page title

const description = `The Banking system provides a comprehensive
 financial overview with three distinct partitions: Cash in Hand, Bank
  Balance, and Bank Balance. This clear display makes it easy to monitor 
  and manage your funds. You can also exercise full control over your
   bank accounts, with the ability to create, activate, deactivate, and delete them.
    The system's core functionality includes syncing live bank feeds to eliminate manual data entry, 
   enabling you to effortlessly match and categorize transactions. This streamlined process ensures accurate reconciliation
    and a precise record of all your business's financial activity.`; // banking description

const banking_images = [
    '/images/banking/banking_overview.png',
    '/images/banking/all_banking_account.png',
    '/images/banking/bank_account_delete.png',
    '/images/banking/bank_account_edit_modal.png',
    '/images/banking/bank_account_edit.png',
    '/images/banking/bank_account_inactive.png',
    '/images/banking/create_account.png',
    '/images/banking/new_banking_account.png',
    '/images/banking/bank_account_detail_view.png',
    '/images/banking/bank_account_table_tip.png',
    '/images/banking/bank_account_delete_confirm.png',
]

const banking_features = [
    {
        title: 'Cash In Hand',
        description: '',
    },
    {
        title: 'Bank Balance',
        description: '',
    },
    {
        title: 'Bank Balance',
        description: '',
    }
];

const all_account_description = `
The "All Accounts" section displays a table of all
 your bank accounts, showing three key columns: Account Details 
 for identification, Uncategorized to quickly find pending transactions,
  and Account Balance for real-time fund tracking. This clear layout
   helps you efficiently manage your finances.`;

const available_action = [
    {
        strong: '+ New',
        description: ' Create a new bank account manually using the bank account creation form'
    },
    {
        strong: 'Details View',
        description: 'To see a detailed view of an account\'s transactions, simply click on its row in the "All Accounts" table.'
    },
    {
        strong: 'Edit Account',
        description: ' To edit an account, hover over the row in the table, click the "Edit" button that appears, and save your changes.'
    },
    {
        strong: 'Inactive',
        description: 'To inactivate an account, hover over its row in the table, click the "Inactive" button that appears, and confirm.'
    },
    {
        strong: 'Delete',
        description: 'To delete an account, hover over its row in the table, click the "Delete" button that appears, and confirm your choice.'
    },

]


const Banking: React.FC = () => {

    return (
        <div className="min-h-screen bg-gray-50">
            <div className="max-w-7xl mx-auto">
                {/* Header */}
                <div className="mb-6">
                    <h1 className="text-3xl font-bold text-gray-900">{title}</h1>
                    <p className="text-gray-600 mt-2">{description}</p>
                </div>

                {/* Main Banking Overview Image */}
                <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6">
                    <div className="mb-6">
                        <img
                            src={banking_images[0]}
                            alt="Products Main Page"
                            className="w-full max-w-4xl h-auto border border-gray-200 rounded-lg shadow-sm mx-auto"
                        />
                    </div>
                </div>

                {/* Banking Features Section */}
                <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6">
                    {
                        banking_features.map((item, index) => (
                            <>
                                <h2 className="text-xl font-semibold text-gray-900 mb-4 pt-4" key={index}>{item.title}</h2>
                                <p className="text-gray-600 pb-4">{item.description}</p>
                                <hr></hr>
                            </>
                        ))
                    }
                </div>

                {/* All Banking Account Table Sections */}
                <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6">
                    <h2 className="text-xl font-semibold text-gray-900 mb-4">All {title} Account</h2>
                    <p className="text-gray-600 mb-4">{all_account_description}</p>

                    {/* Main Banking Overview Image */}
                    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6">
                        <div className="mb-6">
                            <img
                                src={banking_images[1]}
                                alt="Products Main Page"
                                className="w-full max-w-4xl h-auto border border-gray-200 rounded-lg shadow-sm mx-auto"
                            />
                        </div>
                    </div>
                </div>

                {/* Available Actions Section */}
                <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6">
                    <h2 className="text-xl font-semibold text-gray-900 mb-4">Available Actions</h2>
                    <p className="text-gray-600 mb-4">
                        The Banking Account offers several action buttons in the top toolbar and hover on each item:
                    </p>
                    <ul className="list-disc list-inside text-gray-600 space-y-2 mb-4">
                        {
                            available_action.map((item,index)=>(
                                <li key={index}><strong>{item.strong}:</strong> {item.description}</li>
                            ))
                        }
                    </ul>
                    <p className="text-gray-600">These actions help you efficiently manage bank account and maintain data consistency across your system.</p>
                </div>

                {/* New Bank Account creates Section */}
                <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6">
                    <h2 className="text-xl font-semibold text-gray-900 mb-4">{available_action[0].strong}</h2>
                    <p className="text-gray-600 mb-4">
                        To create a new bank account, click the button located in the top-right corner of the page.
                    </p>
                    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6">
                        <div className="mb-6">
                            <img
                                src={banking_images[7]}
                                alt="Products Main Page"
                                className="w-full max-w-4xl h-auto border border-gray-200 rounded-lg shadow-sm mx-auto"
                            />
                        </div>
                    </div>
                    <p className="text-gray-600 mb-4">
                       To create a new account, simply click the button in the top-right corner of the "All Accounts" table. This will open a "create account" pop-up, where you can enter all the necessary bank account details.
                    </p>
                    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6">
                        <div className="mb-6">
                            <img
                                src={banking_images[6]}
                                alt="Products Main Page"
                                className="w-full max-w-4xl h-auto border border-gray-200 rounded-lg shadow-sm mx-auto"
                            />
                        </div>
                    </div>
                </div>

                {/* Detail Table Section */}
                <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6">
                    <h2 className="text-xl font-semibold text-gray-900 mb-4">{available_action[1].strong}</h2>
                    <p className="text-gray-600 mb-4">{available_action[1].description}</p>
                    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6">
                        <div className="mb-6">
                            <img
                                src={banking_images[8]}
                                alt="Products Main Page"
                                className="w-full max-w-4xl h-auto border border-gray-200 rounded-lg shadow-sm mx-auto"
                            />
                        </div>
                    </div>
                </div>

                {/* Edit Table Section */}
                <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6">
                    <h2 className="text-xl font-semibold text-gray-900 mb-4">{available_action[2].strong}</h2>
                    <p className="text-gray-600 mb-4">To edit an account, hover over the row in the table, click the "Edit" button</p>
                    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6">
                        <div className="mb-6">
                            <img
                                src={banking_images[4]}
                                alt="Products Main Page"
                                className="w-full max-w-4xl h-auto border border-gray-200 rounded-lg shadow-sm mx-auto"
                            />
                        </div>
                    </div>
                    <p className="text-gray-600 mb-4">Upon clicking "Edit," the account edit form will open, allowing you to make and save your changes.</p>
                    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6">
                        <div className="mb-6">
                            <img
                                src={banking_images[3]}
                                alt="Products Main Page"
                                className="w-full max-w-4xl h-auto border border-gray-200 rounded-lg shadow-sm mx-auto"
                            />
                        </div>
                    </div>
                </div>

                {/* Inactive Table Section */}
                <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6">
                    <h2 className="text-xl font-semibold text-gray-900 mb-4">{available_action[3].strong}</h2>
                    <p className="text-gray-600 mb-4">{available_action[3].description}</p>
                    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6">
                        <div className="mb-6">
                            <img
                                src={banking_images[5]}
                                alt="Products Main Page"
                                className="w-full max-w-4xl h-auto border border-gray-200 rounded-lg shadow-sm mx-auto"
                            />
                        </div>
                    </div>
                </div>

                {/* Delete Table Section */}
                <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6">
                    <h2 className="text-xl font-semibold text-gray-900 mb-4">{available_action[4].strong}</h2>
                    <p className="text-gray-600 mb-4">{available_action[4].description}</p>
                    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6">
                        <div className="mb-6">
                            <img
                                src={banking_images[2]}
                                alt="Products Main Page"
                                className="w-full max-w-4xl h-auto border border-gray-200 rounded-lg shadow-sm mx-auto"
                            />
                        </div>
                    </div>
                    <p className="text-gray-600 mb-4">To delete, choose OK.</p>
                    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6">
                        <div className="mb-6">
                            <img
                                src={banking_images[10]}
                                alt="Products Main Page"
                                className="w-full max-w-4xl h-auto border border-gray-200 rounded-lg shadow-sm mx-auto"
                            />
                        </div>
                    </div>
                </div>

                {/* Delete Table Section */}
                <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6">
                    <h2 className="text-xl font-semibold text-gray-900 mb-4">Filtering Bank Account</h2>
                    <p className="text-gray-600 mb-4">To filter accounts, click the down arrow icon located next to the "All Accounts" title.</p>
                    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6">
                        <div className="mb-6">
                            <img
                                src={banking_images[9]}
                                alt="Products Main Page"
                                className="w-full max-w-4xl h-auto border border-gray-200 rounded-lg shadow-sm mx-auto"
                            />
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default Banking;
